// src/lib/returnPath.js
//
// Where to go after sign-in (Patient Appointments Task 4). Only an internal
// /patient/ path the guard recorded is honoured -- never an external URL, a
// protocol-relative path, a query string or a fragment, so nothing sensitive
// (and no hold token, which never exists client-side) is resumed.

export const DEFAULT_RETURN_PATH = "/patient/dashboard";

export function safeReturnPath(from) {
  const pathname = typeof from === "string" ? from : from?.pathname;
  if (typeof pathname !== "string") return DEFAULT_RETURN_PATH;
  if (!/^\/patient\/[A-Za-z0-9\-/]*$/.test(pathname) || pathname.includes("//") || pathname.length > 200) {
    return DEFAULT_RETURN_PATH;
  }
  return pathname;
}
